import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResultProc } from '@app/models/system/result-proc.model';
import { environment } from '@enviroments/environment';
import { PrepaySearchModel } from '@app/models/myoffice/order/prepay-search.model';

@Injectable({
    providedIn: 'root'
})
export class PrepayService {

    constructor(private _http: HttpClient) { }

    payCardPrepay(params: any): Observable<ResultProc> {
        let url = `${environment.apiUrl}/payletter-mediuskr/pay`;
        return this._http.post<ResultProc>(url, params);
    }

    savePrepay(params: any): Observable<ResultProc> {
        let url = `${environment.apiUrl}/ordreg/prepay-register/${environment.default_lang}`;
        return this._http.post<ResultProc>(url, params);
    }

    searchPrepay(params: any): Observable<PrepaySearchModel[]> {
        let url = `${environment.apiUrl}/prepay/prepaySearch_Mediuskr?lang=${environment.default_lang}`;
        return this._http.post<PrepaySearchModel[]>(url, params);
    }

    countPrepay(params: any): Observable<Number> {
        let url = `${environment.apiUrl}/prepay/prepayCount_Mediuskr`;
        return this._http.post<Number>(url, params);
    }

    deletePrepay(userid: string, moneyNo: string): Observable<ResultProc> {
        let seq = 0;
        let url = `${environment.apiUrl}/payletter-mediuskr/refund/${environment.comId}/${moneyNo}/${seq}/${userid}`;
        return this._http.get<ResultProc>(url);
    }
}